// @mui material components
import Grid from "@mui/material/Grid";

// mohtasham React components
import MDBox from "components/MDBox";

// mohtasham React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import ProductionQuantityLimitsOutlinedIcon from "@mui/icons-material/ProductionQuantityLimitsOutlined";
import ShoppingCartCheckoutOutlinedIcon from "@mui/icons-material/ShoppingCartCheckoutOutlined";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import PointOfSaleOutlinedIcon from "@mui/icons-material/PointOfSaleOutlined";
import CollectionsOutlinedIcon from "@mui/icons-material/CollectionsOutlined";
// Data
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// mohtasham React contexts
import { useMaterialUIController, setDirection } from "context";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getDashboard } from "controllers/BasicInformationController";
import Footer from "examples/Footer";
import { setLogin } from "context";
import { Card } from "@mui/material";

function Aboutus() {
  const [controller, dispatch] = useMaterialUIController();
  const { sales, tasks } = reportsLineChartData;
  const [data, setData] = useState();

  const navigate = useNavigate();

  useEffect(() => {
    setDirection(dispatch, "rtl");
  }, []);
  return (
    <DashboardLayout>
      {controller.authenticated && <DashboardNavbar title="درباره ما" />}
      <Card>
        <Grid container px={1} py={1}>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{
              backgroundColor: "rgb(48, 191, 194)",
              height: 180,
              justifyContent: "center",
              alignItems: "center",
              textAlign: "justify",
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 30,
              color: "#FFF",
              fontSize:20,
              paddingBottom:30
            }}
          >
            گالری محتشم با ۱۰ سال سابقه در حوزه طراحی و تولید و فروش زیورآلات طلا و نقره پیشرو این
            عرصه در ارایه خدمات برای همکاران گرامی می باشد. خدمات ما را می توانید در لیست زیر مشاهده
            کنید.
          </Grid>
        </Grid>
      </Card>
      <Card style={{marginTop: 10}}>
        <Grid container px={1} py={1}>
          <Grid
            item
            xs={12}
            md={12}
            lg={12}
            style={{
              backgroundColor: "rgb(48, 191, 194)",
              minHeight: 180,
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
              paddingLeft: 20,
              paddingRight: 20,
              paddingTop: 30,
              color: "#FFF",
              fontSize:20
            }}
          >
            <div style={{
              width:"100%",
              color: "rgb(0, 0, 102)", 
              textAlign: "center",
              fontSize:22
            }}>
            لیست خدمات گالری محتشم
            </div>
            <br />
            ۱. حک و برش لیزری
            <br />
            ۲. طراحی ۳ بعدی
            <br />
            ۳. قالب سازی
            <br />
            ۴. ریخته گری
            <br />
            ۵. طراحی ۲ بعدی و تاپیوگرافی
            <br />
            ۶. تعمیرات
            <br />
            ۷. آبکاری
            <br />
            <br />

          </Grid>
        </Grid>
      </Card>
      {controller.authenticated && <Footer />}
    </DashboardLayout>
  );
}

export default Aboutus;
